import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwScrollableContainer extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            inited: false,
            scrollableItemsClass: '.scrollable-container__item',
            arrowRightClass: '.teaser__scrollable--arrowRight',
            arrowLeftClass: '.teaser__scrollable--arrowLeft',
            maxScrollWidth: $el.get(0).scrollWidth - $el.get(0).clientWidth,
            tolerance: 10
        }
    }

    __PageReady(){
        /* Check if container is scrollable */
        if(this.config.maxScrollWidth > 0) {
            this.$el.find(this.config.arrowRightClass).on('click', this.ArrowRightHandler.bind(this));
            this.$el.find(this.config.arrowLeftClass).on('click', this.ArrowLeftHandler.bind(this));
            this.$el.scroll(this.scrollListener.bind(this));
        } else {
            this.$el.find(this.config.arrowRightClass).css({'display' : 'none'})
            this.$el.find(this.config.arrowLeftClass).css({'display' : 'none'})
        }
        //in pageready wegen bildern etc
        this.setMaxScrollWidth();

    }

    setMaxScrollWidth() {
      this.config.maxScrollWidth = this.$el.get(0).scrollWidth - this.$el.get(0).clientWidth;
    }

    setSingleTeaserWidth() {
      this.config.singleTeaserWidth = Math.round(this.$el.find(this.config.scrollableItemsClass).outerWidth(true));
    }

    scrollListener() {
        this.setMaxScrollWidth();
        if(this.$el.get(0).scrollLeft < this.config.tolerance) {
            this.$el.find(this.config.arrowLeftClass).css({'opacity' : '0', 'pointer-events' : 'none'})
        } else if (this.$el.get(0).scrollLeft === this.config.maxScrollWidth) {
            this.$el.find(this.config.arrowRightClass).css({'opacity' : '0', 'pointer-events' : 'none'})
        } else {
            this.$el.find(this.config.arrowLeftClass).css({'opacity' : '1', 'pointer-events' : 'auto'})
            this.$el.find(this.config.arrowRightClass).css({'opacity' : '1', 'pointer-events' : 'auto'})
        }
    }

    ArrowRightHandler() {
      this.setSingleTeaserWidth();
      this.$el.animate({scrollLeft:this.$el.get(0).scrollLeft + this.config.singleTeaserWidth},200,'linear');
    }

    ArrowLeftHandler() {
      this.setSingleTeaserWidth();
      this.$el.animate({scrollLeft:this.$el.get(0).scrollLeft - this.config.singleTeaserWidth},200,'linear');
    }
}


